// TODO: replace with actual placeholder
export const image = 'https://goodpractice.imgix.net/e9857e38-42ea-0007-92e5-9e6f00ad05b6/AAD-8a9c4399-efa5-48ba-89e3-697b4f80169f.jpg?w=700&h=394&q=30&auto=compress&fit=crop&crop=faces%2Cedges&ixlib=js-1.2.0&s=3b23f50358a0bfa42b4053465c8ac71f'
